import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, input } from "@angular/core";
import { BiTranslateDirective, BiTranslatePipe } from "@globals/bi-translate";
import { BiPhoneFormatWithCodePipe } from "@globals/pipes/bi-phone-format-with-code.pipe";

export interface BiAddressInfoTableComponentData {
  name: string;
  phoneCode?: number;
  phoneNumber?: number;
  email?: string;
  companyRegistrationId?: string;
  status?: string;
  isSubscription?: boolean;
}

@Component({
  selector: "bi-address-info-table",
  templateUrl: "./bi-address-info-table.component.html",
  styleUrl: "./bi-address-info-table.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, BiTranslatePipe, BiPhoneFormatWithCodePipe, BiTranslateDirective]
})
export class BiAddressInfoTableComponent implements OnInit {
  recipientsDetails = input.required<BiAddressInfoTableComponentData[]>();
  /**
   * CSS class used for the icon displayed for the contact type (email, phone, etc. )
   */
  contactDetailIconClass = input<string>();

  isStatus = input<boolean>();
  /**
   * Whether the width of the table columns will be set through CSS. This is needed when this component is to be aligned with similar components in parent.
   * Defaults to false, meaning that widths are just set automatically.
   */
  useColumnWidthLimits = input<boolean>();

  recipientType = input.required<"email" | "phone" | "eboks" | "company">();

  show3Columns = input<boolean>();

  public nameColumnTitleTranslationKey: string;
  public titleTranslationKeyForColumn2: string;

  public ngOnInit() {
    this.nameColumnTitleTranslationKey = this.getNameColumnTitleTranslationKey();
    this.titleTranslationKeyForColumn2 = this.getTitleTranslationKeyForColumn2();
  }

  private getNameColumnTitleTranslationKey() {
    switch (this.recipientType()) {
      case "email":
        return "shared.Emails";
      case "phone":
        return "shared.PhoneNumbers";
      case "eboks":
        return "shared.Eboks";
      case "company":
        return "shared.CompanyRegistrationIds";
      default:
        return "";
    }
  }

  private getTitleTranslationKeyForColumn2() {
    switch (this.recipientType()) {
      case "eboks":
        return "shared.Status";
      case "company":
        return "shared.CompanyRegistrationId";
      default:
        return "";
    }
  }
}
